const rankings = [
  {
    rank: 1,
    title: '《沙丘2》',
    subtitle: '科幻史诗续作',
    hot: '9.8',
    tag: '热播中',
    change: 'up',
  },
  {
    rank: 2,
    title: '《奥本海默》',
    subtitle: '诺兰年度巨制',
    hot: '9.7',
    tag: '高分推荐',
    change: 'up',
  },
  {
    rank: 3,
    title: '《周处除三害》',
    subtitle: '华语动作黑马',
    hot: '9.5',
    tag: '新上架',
    change: 'new',
  },
  {
    rank: 4,
    title: '《可怜的东西》',
    subtitle: '威尼斯金狮奖',
    hot: '9.3',
    tag: '文艺精选',
    change: 'down',
  },
  {
    rank: 5,
    title: '《哥斯拉-1.0》',
    subtitle: '日本视觉奇观',
    hot: '9.1',
    tag: '特效大片',
    change: 'up',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-50 mb-3">
            热播排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            本周影迷最爱的高清片源，热度持续飙升中
          </p>
        </div>

        <div className="max-w-2xl mx-auto space-y-3">
          {rankings.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-4 bg-background-100/80 rounded-lg p-4 border border-background-200/50 hover:border-primary-500/20 transition-colors duration-200 group cursor-pointer"
            >
              <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`font-heading text-xl font-bold ${
                      item.rank === 1
                        ? 'text-primary-500'
                        : item.rank === 2
                          ? 'text-accent-500'
                          : 'text-secondary-400'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="font-heading text-lg text-foreground-600">{item.rank}</span>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-200 group-hover:text-primary-400 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-600 mt-0.5">{item.subtitle}</p>
              </div>
              <div className="flex items-center gap-2 flex-shrink-0">
                <span className="w-4 h-4 flex items-center justify-center">
                  {item.change === 'up' && <i className="ri-arrow-up-line text-accent-500 text-sm"></i>}
                  {item.change === 'down' && <i className="ri-arrow-down-line text-secondary-500 text-sm"></i>}
                  {item.change === 'new' && <i className="ri-sparkling-line text-primary-500 text-sm"></i>}
                </span>
                <span className="text-sm font-bold text-accent-500 font-heading">{item.hot}</span>
                <span className="text-xs text-foreground-600 bg-background-200/60 px-2 py-0.5 rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}